var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetUsage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 77.073,
    viewBox: "0 0 77 77.073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14391",
    "data-name": "Group 14391",
    transform: "translate(0 0.046)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14392",
    "data-name": "Group 14392"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11301",
    "data-name": "Path 11301",
    d: "M38.5.527a38,38,0,1,0,38,38A38,38,0,0,0,38.5.527Zm0,62.01a24.011,24.011,0,1,1,24-24.022v.012A24.015,24.015,0,0,1,38.5,62.537Z",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11302",
    "data-name": "Path 11302",
    d: "M76.5,38.527A37.884,37.884,0,0,1,65.363,65.4l-9.892-9.892A24.012,24.012,0,1,0,14.793,34.656L.988,32.4A38,38,0,0,1,76.5,38.528Z",
    fill: "var(--secondaryColor)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11303",
    "data-name": "Path 11303",
    d: "M76.5,38.527A37.884,37.884,0,0,1,65.363,65.4l-9.892-9.892A24.012,24.012,0,1,0,14.793,34.656L.988,32.4A38,38,0,0,1,76.5,38.528Z",
    fill: "none",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11305",
    "data-name": "Path 11305",
    d: "M32.05,26.4h0a5.513,5.513,0,1,1-.187,11.025h0A5.513,5.513,0,1,1,32.05,26.4Z",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5365",
    "data-name": "Rectangle 5365",
    width: 11.025,
    height: 11.025,
    rx: 0.959,
    transform: "translate(39.607 26.445)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5366",
    "data-name": "Rectangle 5366",
    d: "M.959,0h9.108a.958.958,0,0,1,.958.958v9.108a.959.959,0,0,1-.959.959H.959A.959.959,0,0,1,0,10.066V.959A.959.959,0,0,1,.959,0Z",
    transform: "translate(26.345 39.627)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5367",
    "data-name": "Rectangle 5367",
    d: "M.959,0h9.108a.958.958,0,0,1,.958.958v9.108a.959.959,0,0,1-.959.959H.959A.959.959,0,0,1,0,10.066V.959A.959.959,0,0,1,.959,0Z",
    transform: "translate(39.607 39.627)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetUsage);
export default __webpack_public_path__ + "static/media/setUsage.31247d82367fa6d001c0b8b2a9ec4a09.svg";
export { ForwardRef as ReactComponent };